import { Observable, Subject } from 'rxjs';

export class Reboot {
  private static instance: Reboot;
  private _reboot: Subject<boolean> = new Subject();
  private reboot = this._reboot.asObservable();

  /**
   * Returns the BootControl instance
   *
   * @return Reboot
   */
  public static getBootControl(): Reboot {
    if (!Reboot.instance) {
      Reboot.instance = new Reboot();
    }
    return Reboot.instance;
  }

  /**
   * Watches any reboot calls.
   *
   * @return {Observable<boolean>}
   */
  public watchReboot(): Observable<boolean> {
    return this.reboot;
  }

  /**
   * Restarts the app.
   */
  public restart(): void {
    this._reboot.next(true);
  }
}